import { Form } from 'antd';
import { AppModal } from '../../../../../../../../../../../ui/AppModal';
import { useLocalization } from '../../../../../../../../../../../lib/hooks/useLocalization';
import { AddProductForm } from './AddProductForm';
import { useResetFormOnCloseModal } from '../../../../../../../../../lib/hooks/useResetFormOnCloseModal';

export function AddProductModal({ close, isOpen, isModalLoading }) {
  const { title } = useLocalization().translations.unique.pages.products.addModal;
  const [form] = Form.useForm();

  useResetFormOnCloseModal({ form, isOpen });

  return (
    <AppModal
      open={isOpen}
      width={936}
      titleProps={{ textValue: title }}
      cancelButtonProps={{ onClick: close }}
      actionButtonProps={{ onClick: form.submit, loading: isModalLoading }}
    >
      {isOpen && <AddProductForm form={form} />}
    </AppModal>
  );
}
